export const environment = {
  env: "DEV",
  production: false,
  serviceWorkerEnabled: true,
  baseUrl: "https://chat-dev.roarinc.com",
  apiUrl: 'https://apidev.roarinc.it/comms'
};